/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react'
import { useAuth } from '../../hooks/auth'
import { apiAuth } from '../../services/apiAuth'

type SuppliersData = {
  id: string
  trading_name: string
}

type CostOfCenterData = {
  id: string
  name: string
}

type PaymentMethodsData = {
  id: string
  name: string
}

type SupplierData = SuppliersData | null

type CostData = CostOfCenterData | null

interface Categories {
  id: number
  name: string
  name_es: string
  name_en: string
  name_ptbr: string
  is_active: boolean
}

export const useService = () => {
  // Clinic Id Get decode hook
  const { clinicId, decodeToken } = useAuth()

  // State
  const [suppliers, setSuppliers] = useState<SuppliersData[]>([])
  const [costOfCenter, setCostOfCenter] = useState<CostOfCenterData[]>([])
  const [categories, setCategories] = useState<Categories[]>([])
  const [paymentsForm, setPaymentForm] = useState<PaymentMethodsData[]>([])
  const [recoverSuppliers, setRecoverSuppliers] = useState<SupplierData>(null)
  const [recCostOfCenter, setRecCostOfCenter] = useState<CostData>(null)

  const getCostsByClinicId = useCallback(async () => {
    try {
      const { data } = await apiAuth.get(`clinics/${clinicId}/cost-centers/`, {
        params: {
          is_active: true
        }
      })

      setCostOfCenter(data.results)
    } catch (error) {
      console.log('Error getting Cost', error)
    }
  }, [])

  const getSuppliersByClinicId = useCallback(async () => {
    try {
      const { data } = await apiAuth.get(`clinics/${clinicId}/suppliers/`, {
        params: {
          is_active: true
        }
      })

      setSuppliers(data.results)
    } catch (error) {
      console.log('Error getting Suppliers', error)
    }
  }, [])

  const getPaymentFormByClinicId = useCallback(async () => {
    try {
      const { data } = await apiAuth.get(
        `clinics/${clinicId}/payment-sources/`,
        {
          params: {
            is_active: true
          }
        }
      )

      setPaymentForm(data.results)
    } catch (error) {
      console.log('Error getting Suppliers', error)
    }
  }, [])

  const getSupplierById = useCallback(async (id: string) => {
    try {
      const { data } = await apiAuth.get(`clinics/suppliers/${id}/`)

      setRecoverSuppliers(data)
    } catch (error) {
      console.log('Error getting Suppliers', error)
    }
  }, [])

  const getCostById = useCallback(async (id: string) => {
    try {
      const { data } = await apiAuth.get(`clinics/cost-centers/${id}/`)

      setRecCostOfCenter(data)
    } catch (error) {
      console.log('Error getting cost', error)
    }
  }, [])

  const getCategoriesAllClinics = useCallback(async () => {
    const { data } = await apiAuth.get('clinics/payable-categories/')
    setCategories(data?.results)
  }, [])

  useEffect(() => {
    getCostsByClinicId()
    getSuppliersByClinicId()
    getPaymentFormByClinicId()
    getCategoriesAllClinics()
  }, [])

  // Get Value of my select Supplier
  const newSuppliersFormats = suppliers.map((supplier: SuppliersData) => {
    return {
      value: String(supplier.id),
      label: supplier.trading_name
    }
  })

  // Get Value of my select Cost
  const newCostsFormats = costOfCenter.map((cost: CostOfCenterData) => {
    return {
      value: String(cost.id),
      label: cost.name
    }
  })

  // Get Value of my select Cost
  const newPaymentMethods = paymentsForm.map((payment: PaymentMethodsData) => {
    return {
      value: String(payment.id),
      label: payment.name
    }
  })

  // Get Values of my select Category
  const newCategoriesFormats = categories.map((category: Categories) => {
    let name = ''

    switch (decodeToken.clinic_language) {
      case 'en':
        name = category.name_en
        break
      case 'es':
        name = category.name_es
        break

      default:
        name = category.name_ptbr
        break
    }

    return {
      value: String(category.id),
      label: name
    }
  })

  return {
    newSuppliersFormats,
    newCostsFormats,
    newPaymentMethods,
    getSupplierById,
    getCostById,
    recoverSuppliers,
    recCostOfCenter,
    newCategoriesFormats
  }
}
